<template>
  <div>
    <div class="white-background list-top-margin">
      <!-- 面包屑导航 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>库存管理</el-breadcrumb-item>
          <el-breadcrumb-item><span @click="goBack" style="cursor:pointer;">入库单</span></el-breadcrumb-item>
          <el-breadcrumb-item>
            <span style="color:#000;font-weight:bold;" v-if="mode == 'create'">创建入库单</span>
            <span style="color:#000;font-weight:bold;" v-if="mode != 'create'">编辑入库单</span>
          </el-breadcrumb-item>
      </el-breadcrumb>
      <!-- <el-divider></el-divider> -->
      <el-form ref="form" :model="form"  :rules="formRule" label-width="100px" class="order-form">
          <el-row>
              <el-col :span="8">
                  <el-form-item label="入库单号">
                      <el-input size="small" v-model="form.instockCode" :readonly="this.mode != 'create'" placeholder="输入单据编号，忽略将自动生成"></el-input>
                  </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="入库类型" prop="instockType">
                  <el-select
                     size="small"
                        v-model="form.instockType"
                        clearable
                        filterable
                        placeholder="请选择入库类型"
                        style="width:100%;"
                      >
                        <el-option
                          v-for="item in instockTypeList"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                  <el-form-item label="入库时间" prop="instockTime">
                    <el-date-picker
                    size="small"
                      style="width: 100%;"
                      v-model="form.instockTime"
                      type="datetime"
                      placeholder="选择日入库时间"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      default-time="12:00:00">
                    </el-date-picker>
                  </el-form-item>
              </el-col>
          </el-row>
          <el-row>
              <el-col :span="16">
                  <el-form-item label="备注" prop="remark">
                      <el-input size="small" v-model="form.remark" type="textarea" :rows="2"></el-input>
                  </el-form-item>
              </el-col>


              <!-- <el-col :span="8">
                  <el-form-item label="客户名称" prop="nodata" >
                      <el-input size="small" v-model="form.nodata" placeholder="输入客户名称"></el-input>
                  </el-form-item>
              </el-col> -->
          </el-row>
          <FormItem :setList="setList" :form="form" :colSpan="8" :mode="mode" v-if="showChild"></FormItem>
      </el-form>
    </div>
    <div class="white-background">
      <div class="default-title defult-row-margin">入库明细</div>
      <el-row class="tbl-btn" v-if="mode == 'create'">
          <el-col :span="12" class="tbl-btn-left">
              <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="addProduct" >添加产品</el-button>
              <!--<el-button type="primary" size="small" icon="el-icon-download" plain>导入数据</el-button>-->
          </el-col>
          <!-- <el-col :span="12" class="tbl-btn-right">
              <el-button type="default" size="small" icon="el-icon-s-operation">列配置</el-button>
          </el-col> -->
      </el-row>
      <!--列表-->
      <el-table
      size="small"
      :data="listData"
      highlight-current-row
      v-loading="loading"
      stripe
      border
      element-loading-text="加载中"
      :header-cell-style="_headerStyle"
      style="width: 100%;"
      >
      <el-table-column align="left" type="index" width="50" label="序号">
      </el-table-column>
      <el-table-column  prop="productCode" label="产品编号"  >
          <template slot-scope="scope">
          <el-tooltip :content="scope.row.productCode" placement="top">
              <span class="txt-overflow" >{{scope.row.productCode}}</span>
          </el-tooltip>
          </template>
      </el-table-column>
      <el-table-column  label="产品名称" >
          <template slot-scope="scope">
          <el-tooltip :content="scope.row.productName" placement="top">
              <span class="txt-overflow">{{scope.row.productName}}</span>
          </el-tooltip>
          </template>
      </el-table-column>

      <el-table-column  label="产品规格" >
          <template slot-scope="scope">
          <el-tooltip :content="scope.row.specs" placement="top">
              <span class="txt-overflow">{{scope.row.specs}}</span>
          </el-tooltip>
          </template>
      </el-table-column>
      <el-table-column  prop="source" label="产品属性" >
      </el-table-column>
      <el-table-column  prop="unit" label="库存单位" >
      </el-table-column>
      <!-- <el-table-column  prop="minStock" label="最小库存" width="90">
      </el-table-column>
      <el-table-column  prop="maxStock" label="最大库存" width="90">
      </el-table-column>
      <el-table-column  prop="safeStock" label="安全库存" width="90">
      </el-table-column> -->
      <el-table-column  prop="stockNum" label="当前库存量">
        <template slot="header">
          <div>
            <span>当前库存量</span>
            <el-tooltip content="当前实时库存数量，供参考" placement="top">
              <i class="el-icon-info message-icon"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column  prop="instockNum" label="入库数量" >
        <!-- <template slot-scope="scope">
            <el-input-number v-model="scope.row.instockNum" @change="handleChange" size="mini" controls-position="right" :min="1" :max="9007199254740991" label="请填写" style="width: 100%;"></el-input-number>
          </template> -->
          <template slot-scope="scope">
            <el-input-number
            size="mini"
              class="input-number"
              style="width: 100%;"
              v-model="instockNum"
              controls-position="right"
              :min="1"
              placeholder="请填写"
              v-if="scope.row.isEnable"
            ></el-input-number>
            <span v-if="!scope.row.isEnable" :title="scope.row.instockNum">{{scope.row.instockNum}}</span>
          </template>
      </el-table-column>
      <!-- <el-table-column  prop="number" label="入库数量" width="120">
          <template slot-scope="scope">
              <el-input-number v-model="scope.row.number" @change="handleChange" size="mini" controls-position="right" :min="1" :max="9007199254740991" label="请填写" style="width: 100%;"></el-input-number>
          </template>
      </el-table-column>
      <el-table-column  prop="type" label="类别" width="90">
        <template slot-scope="scope">
            <el-tag  :type="scope.row.type == '半成品' ? 'success' : 'danger'">{{scope.row.type}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column  prop="deptNo" label="客户物料编号" width="120">
      </el-table-column>
      <el-table-column  prop="deptNo" label="订单编号" width="200">
      </el-table-column> -->
      <!-- <el-table-column align="left"  label="操作" max-width="120" fixed="right">
          <template slot-scope="scope">
          <el-tooltip content="删除" v-if="mode == 'create'">
              <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>
          </el-tooltip>
          </template>
      </el-table-column> -->
      <el-table-column align="left"  label="操作" width="150">
            <template slot-scope="scope">
              <el-tooltip content="保存" v-if="scope.row.isEnable">
                <el-button type="success" size="mini" icon="el-icon-check" circle @click="handletblSave(scope.$index, scope.row)"></el-button>

              </el-tooltip>
              <el-tooltip content="取消" v-if="scope.row.isEnable">
                <el-button type="info" size="mini" icon="el-icon-minus" circle @click="handleCancel(scope.$index, scope.row)"></el-button>

              </el-tooltip>

              <el-tooltip content="编辑" v-if="!scope.row.isEnable">
                  <el-button type="primary" size="mini" icon="el-icon-edit" circle @click="handleEdit(scope.$index, scope.row)"></el-button>

              </el-tooltip>
              <el-tooltip content="删除" v-if="mode == 'create'">
                  <el-button size="mini" type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.$index, scope.row)"></el-button>

              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
    </div>
      <CreateProduct :diaVisible="isAddProdVisible" v-if="isAddProdVisible" @close="close" @save="save"></CreateProduct>
      <div class="self-panel-bottom">
         <el-button size="small" type="default"  @click="handleClose">取消</el-button>
         <el-button size="small" type="primary"  @click="handleSave">保存</el-button>
     </div>
  </div>
</template>
<script>
import moment from 'moment'
import { instockSave } from '@/api/basicData'
import CreateProduct from './CreateProduct';
import FormItem from "@/components/FormItem";

export default {
  name:'createGoods',
  components:{CreateProduct,FormItem},
  props:{
      userData:{
          type:Object,
          default:{},
      },
      mode:{
        type:String,
        default:''
      },
      editRow:{
          type:Object,
          default:{},
      },
      setList:{
        type:Array,
        default:[]
      }
  },
  data(){
      return {
          isAddProdVisible:false,
          form:{
            instockCode:'',
            instockType:'',
            instockTime:'',
          },
          loading:false,
          listData:[],
          formRule:{
              instockType: [{
                  required: true,
                  message: "请选择入库类型",
                  trigger: ["blur",'change'],
              },] ,
              instockTime: [{
                  required: true,
                  message: "请选择入库时间",
                  trigger: ["blur",'change'],
              },]
          },
          instockTypeList: [{
            label:'普通入库',
            value:'普通入库'
          },{
            label:'退料入库',
            value:'退料入库'
          },{
            label:'采购入库',
            value:'采购入库'
          },{
            label:'成品入库',
            value:'成品入库'
          },{
            label:'调拨入库',
            value:'调拨入库'
          },{
            label:'销售退货入库',
            value:'销售退货入库'
          },{
            label:'其他入库',
            value:'其他入库'
        }],
        showChild:true,
        instockNum:0

      }
  },
  created(){
    this.showChild = true;
    if(this.mode == 'create'){
      this.form.instockTime = moment().format('YYYY-MM-DD HH:mm:ss')
    }else{
      this.form  = JSON.parse(JSON.stringify(this.editRow));
      this.listData = this.form.instockList;
    }

  },
  methods:{
      /**
       * 返回上一级
       */
      goBack(){
        this.showChild = false;
        this.$emit("goBack");
      },
      handletblSave(index,row){
        row['instockNum'] = this.instockNum;
        row['isEnable'] = false;
        this.listData = JSON.parse(JSON.stringify(this.listData));

      },
      handleCancel(index,row){
        row['isEnable'] = false;
        this.listData = JSON.parse(JSON.stringify(this.listData));

      },
      handleEdit(index,row){
        this.instockNum = row['instockNum'];
        row['isEnable'] = true;
        this.listData = JSON.parse(JSON.stringify(this.listData));
      },
      handleDelete(index,row){
        this.listData.splice(index,1);
      },
      handleChange(){},
      addProduct(){
          this.isAddProdVisible = true;
      },
      close(){
        this.showChild = false;
        this.isAddProdVisible = false;
      },
      save(options){
        if(options.product){
          var data = JSON.parse(JSON.stringify(options.product))
          data.instockNum = options.form.instockNum
          this.listData.push(data);
        }
        this.close()
      },
      changeStatusColor(options){
        if(options == '逾'){
          return 'danger'
        }else if(options == '执行中'){
          return 'success'
        }{
          return ''
        }
      },
      handleClose(){
        this.$emit("goBack",{type:'cancel'});
      },
      handleSave(){
        this.$refs.form.validate((valid) => {
          if (valid) {
            var data = JSON.parse(JSON.stringify(this.form));
            data.factoryId = this.userData.factoryId;
            data.instockList = JSON.stringify(this.listData);
            if(this.mode == 'create'){

              data.creater = this.userData.name+'('+this.userData.account+')';
            }
              data.updater = this.userData.name+'('+this.userData.account+')';


            instockSave(data).then(res => {
              if(res.code == 200){
                this.$message.success('保存成功')
                this.$emit('done',{type:'save'})
                this.dialogVisible = false;
                this.$emit("goBack",{type:'save'});
              }else{
                this.$message.error(res.msg)
              }
            }).catch(err => {
              this.$message.error(err)
            })
          }

      })
    },

  },

}
</script>
<style scoped>
  .order-form{
      margin-top: 15px;
  }
  .tbl-btn{
      width: 100%;
      height: 50px;
      line-height: 50px;

  }
  .tbl-btn .tbl-btn-right{
      text-align: right;
  }
  .txt-overflow{
      text-overflow:ellipsis;
      white-space:nowrap;
  }

</style>



// WEBPACK FOOTER //
// src/views/stockManagement/warehousingOrder/CreateLayout.vue